import { Pipe, PipeTransform } from "@angular/core";
import { TerritoryRouteTypeColorsEnum, TerritoryRouteTypeEnum } from "../utilities/enums/TerritoriesEnum";
import { TerritoriesLayerControlService } from "../services/TerritoriesLayerControl.service";
import { TerritoriesListItem } from "../Models/TerritoriesListItem";

@Pipe({ name: 'isTerritorySelected' })
export class IsTerritorySelectedPipe implements PipeTransform {
  transform(item: TerritoriesListItem, selectedItems: Set<string>): boolean {
    return selectedItems.has(item.idTerritory);
  }
}